import { useGetBonusOffers } from './hooks';

function BonusOffers({ children }) {
  useGetBonusOffers();

  return children || null;
}

export default BonusOffers;
